import React from 'react'
import PropTypes from 'prop-types'
import {connect} from 'react-redux'
import classNames from 'classnames'

import * as pane from '../../../store/pane'

function ReviewMeter(props) {
  const titleClasses = classNames('review-meter-title', {
    'is--inactive': !props.score,
  })

  function renderMeterMobile() {
    let meterScore = 'N/A'
    if (props.isPhone) {
      if (props.score) {
        meterScore = `${props.score}/5`
      }
    }
    return meterScore
  }

  function renderMeterScore() {
    return [1, 2, 3, 4, 5].map((item) => (
      <div
        className={classNames('review-meter-ball', {
          'is--active': props.score && props.score === item,
          'is--inactive': !props.score,
        })}
        key={item}
      />
    ))
  }

  return (
    <div className="product-review-meter">
      <p className={titleClasses}>
        {props.title} {props.isPhone ? renderMeterMobile() : null}
      </p>
      <div className="review-meter">
        {props.isPhone ? null : renderMeterScore()}
        <div className="meter-line" />
      </div>
    </div>
  )
}

ReviewMeter.propTypes = {
  isPhone: PropTypes.bool.isRequired,
  score: PropTypes.number,
  title: PropTypes.string.isRequired,
}

ReviewMeter.defaultProps = {
  score: null,
}

const mapStateToProps = (state) => ({
  isPhone: pane.windowIsPhone(state),
})

export default connect(mapStateToProps)(ReviewMeter)
